import React from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { windowAmplitudeTrack } from '../../../../shared/helpers/utils'
import Icon from '../../../../shared/components/atoms/Icon'

import './styles.scss'

const Gift = ({
  product,
  addChosenProduct,
  setIsSelectionVisible,
  subscriptionInCart,
  cart,
  gifts,
  secondStepGiftsAvailable
}) => {
  const { t } = useTranslation()

  const _classnames = classNames('gift-item', { subscriptionInCart })
  const _giftItemsWrapper = classNames({ 'gift-item-wrapper': !subscriptionInCart })

  const onAddGift = () => {
    addChosenProduct(product, secondStepGiftsAvailable)
    setIsSelectionVisible(false)
  }

  const isSelected = () => gifts.includes(product.sku) && cart?.items.some(item => item.sku === product.sku)

  const track = () => windowAmplitudeTrack('IncentiveCartToggleGiftSelected')

  const setWelcomeKitContextLocally = () => window.localStorage.setItem('welcomeKitContext', 'true')

  return (
    <div className={_giftItemsWrapper}>
      <div
        className={_classnames}
        key={product.sku}
        onClick={onAddGift}
      >
        <img src={product.variant_image_url || product.image_url} />
        <div className='gift-content'>
          <div className='gift-text'>
            <div className='gift-title'>{product.title}</div>
            <div className='gift-variant'>{product.variant_title || product.title}</div>
            {subscriptionInCart &&
              <div className='gift-price'>
                <span><del>{t('general:dynamicPrice', { price: product.price })}</del></span>
              </div>}
          </div>

          {/*
            Use this code if we want to apply the following styles for welcome-kit offer:
              - https://www.figma.com/file/XaNYeP7tEmfRwmkMXgEyWv/Add-to-cart---Panier-incentivant?node-id=2301%3A18029

            <ToggleBtn
              onChecked={() => { addGift(); setTimeout(() => setIsSelectionVisible(false), 700) }}
              onUnChecked={() => removeGift()}
            />
          */}

          <label className='gift-checkbox'>
            <span
              className={classNames('gift-circle', { checked: isSelected() })}
              onClick={(e) => { setWelcomeKitContextLocally(); track() }}
            >
              {isSelected() && <Icon iconName='circle' />}
            </span>
          </label>
        </div>
      </div>

      {subscriptionInCart}
    </div>
  )
}

export default Gift
